<template>
    <v-layout class="component-wrap">
        <Contact />
    </v-layout>
</template>

<script>
import Contact   from '@/components/view_blocks/Contact/Contact_wrap';

export default {
  components: {
    Contact,
  },
};
</script>

